exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.separator[data-v-0a41af18] {\r\n  width: 100%;\r\n  border-width: 1px;\r\n  height: 12px;\r\n  border-color: #111111;\r\n  display: block;\n}\n.spacer[data-v-0a41af18] {\r\n  height: 100px;\n}\n.md-menu-content[data-v-0a41af18] {\r\n  width: 600px;\n}\r\n", ""]);

// exports
